export default {
  getMyDistributeOrders: '/wdsx-shop/orderGoods/getMyDistributeOrders',
  getBankCardList: '/wdsx-shop/userBankCard/selfUserBankCardList',
  addBankCard: '/wdsx-shop/userBankCard/addUserBankCard',
  getCommission: '/wdsx-shop/user/getCommission',
  getAssetBreakdown: '/wdsx-shop/distributionWater/selfPageList',
  applyWithdraw: '/wdsx-shop/withdraw/apply',
  deleteBankCard: '/wdsx-shop/userBankCard/delUserBankCard'
};
